import { useParams } from 'react-router-dom';
import { useDetaildOrderQuery } from '../../services/orderApi'
import { useReactToPrint } from 'react-to-print';
import './orderDetails.css'
import OrderdProducts from './OrderedProducts';
import OrderTrack from './OrderTrack';
import { useRef } from 'react';
import { ReceiptLongOutlined } from "@mui/icons-material";
import { AdminPageHeader, AdminCard, AdminButton, AdminSkeleton, AdminEmptyState } from '../../components/ui'
import { formatDateTime, formatDateTimeIso, formatAddress } from '../../utils/format'

const InfoRow = ({ label, value }) => (
  <div className="orderInfoRow">
    <span className="orderInfoRow__label">{label}</span>
    <span className="orderInfoRow__value">{value}</span>
  </div>
);

const OrderDetails = () => {
  const { id } = useParams()
  const responseInfo = useDetaildOrderQuery(id);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'Order_Invoice',
  })

  const breadcrumbs = [{ label: "Dashboard", to: "/admin/dashboard" }, { label: "Orders", to: "/admin/orders" }, { label: `#${id}` }];

  if (responseInfo.isLoading) {
    return (
      <div>
        <AdminPageHeader title="Order Invoice" breadcrumbs={breadcrumbs} />
        <AdminCard><AdminSkeleton variant="card" height={300} /></AdminCard>
      </div>
    );
  }

  if (responseInfo.isError) {
    return (
      <div>
        <AdminPageHeader title="Order Invoice" breadcrumbs={breadcrumbs} />
        <AdminEmptyState icon={<ReceiptLongOutlined />} title="Couldn't load this order" description="Something went wrong. Try refreshing the page." />
      </div>
    );
  }

  const order = responseInfo.data;

  return (
    <div>
      <AdminPageHeader
        title="Order Invoice"
        breadcrumbs={breadcrumbs}
        primaryAction={<AdminButton onClick={handlePrint}>Print Invoice</AdminButton>}
      />
      <div ref={componentRef}>
        <AdminCard className="orderDetailsCard">
          <h2 className="orderDetailsCard__heading">Order Status</h2>
          <OrderTrack data={order} />

          <div className="orderDetailsCard__divider" />

          <div className="orderDetailsCard__row">
            <h2 className="orderDetailsCard__heading">Order Details</h2>
            <h2 className="orderDetailsCard__heading orderDetailsCard__heading--right">Delivery Address</h2>
          </div>
          <div className="orderInfoGrid">
            <div className="orderInfoGrid__col">
              <InfoRow label="Order ID" value={order.order_Id} />
              <InfoRow label="Placement Date/Time" value={formatDateTime(order.order_Placment_Date, order.order_Placment_Time)} />
              <InfoRow label="Delivery Charges" value={`₹${Number(order.delivery_Charges).toFixed(2)}`} />
              <InfoRow label="Total Amount" value={`₹${Number(order.total_Amount).toFixed(2)}`} />
              <InfoRow label="Note" value={order.note} />
            </div>
            <div className="orderInfoGrid__col">
              <InfoRow label="Customer" value={`${order.customer.first_Name} ${order.customer.last_Name}`} />
              <InfoRow label="Phone Number" value={order.customer.phone_Number} />
              <InfoRow label="Delivery Address" value={formatAddress(order.address)} />
              <InfoRow label="Delivery Date" value={formatDateTimeIso(order.order_Delivery_Date)} />
              <InfoRow label="Delivery Time Slot" value={order.order_Delivery_Time} />
            </div>
          </div>

          <div className="orderDetailsCard__divider" />

          <h2 className="orderDetailsCard__heading">Payment</h2>
          <div className="orderInfoGrid">
            <div className="orderInfoGrid__col">
              <InfoRow label="Payment ID" value={order.payment.payment_Id} />
              <InfoRow label="Payment Status" value={order.payment.payment_Status} />
            </div>
            <div className="orderInfoGrid__col">
              <InfoRow label="Payment Type" value={order.payment.payment_Type} />
              <InfoRow label="Amount Paid" value={`₹${Number(order.payment.amount_Paid).toFixed(2)}`} />
            </div>
          </div>

          <div className="orderDetailsCard__divider" />

          <h2 className="orderDetailsCard__heading">Products</h2>
          <OrderdProducts data={id} />
        </AdminCard>
      </div>
    </div>
  )
}

export default OrderDetails
